/**
 * Auction Countdown - Global Script
 * Reads auction data from #auction-data JSON element and initializes
 * all countdown timers and last bid displays on the page.
 */
document.addEventListener('DOMContentLoaded', function () {
  var dataEl = document.getElementById('auction-data');
  if (!dataEl) return;

  var auctionData;
  try {
    auctionData = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  if (!auctionData) return;

  // Find all countdown elements and initialize them
  var countdowns = document.querySelectorAll('.countdown[data-product-id]');
  countdowns.forEach(function (el) {
    var productID = el.getAttribute('data-product-id');
    var productData = auctionData[productID];
    if (productData) {
      startCountdownAndGetLastBid(productData, productID);
    }
  });

  function getBidByProductId(productData) {
    if (!productData) return null;
    if (productData.latestBid && Object.keys(productData.latestBid).length > 0) {
      return productData.latestBid.Lance;
    } else if (productData.PrecoInicial) {
      return productData.PrecoInicial;
    }
    return null;
  }

  function countdownTimer(endDate, productID) {
    var end = new Date(endDate);
    var interval = setInterval(function () {
      var now = new Date();
      var difference = end - now;
      var timeLeft;

      if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      } else {
        timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        clearInterval(interval);
      }

      updateCountdownDisplay(productID, timeLeft);
    }, 1000);
  }

  function updateCountdownDisplay(productID, time) {
    var countdown = document.querySelector(
      '.countdown[data-product-id="' + productID + '"]'
    );
    if (!countdown) return;
    countdown.querySelector('.days').textContent = time.days;
    countdown.querySelector('.hours').textContent = time.hours;
    countdown.querySelector('.minutes').textContent = time.minutes;
    countdown.querySelector('.seconds').textContent = time.seconds;
    countdown.style.display = 'flex';
  }

  function updateDisplay(productID, isVisible) {
    var lastBidElement = document.querySelector(
      '.lastBid[data-product-id="' + productID + '"]'
    );
    if (!lastBidElement) return;
    lastBidElement.style.display = isVisible ? 'block' : 'none';
  }

  function formatCurrency(value) {
    var numericValue = Number(value);
    return numericValue.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }

  function startCountdownAndGetLastBid(productData, productID) {
    var lastBid = getBidByProductId(productData);
    var lastBidElement = document.querySelector(
      '.lastBid[data-product-id="' + productID + '"]'
    );

    if (lastBid && lastBidElement) {
      lastBidElement.innerHTML = 'Lance atual ' + formatCurrency(lastBid);
      updateDisplay(productID, true);
    } else {
      updateDisplay(productID, false);
    }

    if (productData && productData.DataFim) {
      countdownTimer(productData.DataFim, productID);
    }
  }
});
